import { List } from '@mui/material'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function CustomFields(props: Props) {
  const {
    extOrder: {
      orderStep: { customFields = {} },
    },
  } = props

  const texts = useTexts()

  const hasCustomFields = Object.keys(customFields).length > 0

  if (!hasCustomFields) {
    return (
      <preview.Field label={texts.customFields.label}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  return (
    <preview.Field label={texts.customFields.label}>
      <List dense disablePadding component="span">
        {Object.entries(customFields).map(([key, value]) => (
          <preview.LabelValueRow
            key={`${key}-${value}`}
            label={key}
            valueTooltip={value}
            splitEvenly
          >
            {value}
          </preview.LabelValueRow>
        ))}
      </List>
    </preview.Field>
  )
}
